import { type MRT_Localization } from "mantine-react-table";

export const MRT_LOCALIZATION_VI: MRT_Localization = {
  actions: "Thao tác",
  and: "và",
  cancel: "Hủy",
  changeFilterMode: "Thay đổi chế độ lọc",
  changeSearchMode: "Thay đổi chế độ tìm kiếm",
  clearFilter: "Xóa bộ lọc",
  clearSearch: "Xóa tìm kiếm",
  clearSelection: "Bỏ chọn",
  clearSort: "Hủy sắp xếp",
  clickToCopy: "Nhấn để sao chép",
  collapse: "Thu gọn",
  collapseAll: "Thu gọn tất cả",
  columnActions: "Thao tác cột",
  copiedToClipboard: "Đã sao chép vào khay nhớ tạm",
  copy: "Sao chép",
  dropToGroupBy: "Kéo thả vào đây để nhóm theo {column}",
  edit: "Chỉnh sửa",
  expand: "Mở rộng",
  expandAll: "Mở rộng tất cả",
  filterArrIncludes: "Bao gồm",
  filterArrIncludesAll: "Bao gồm tất cả",
  filterArrIncludesSome: "Bao gồm một số",
  filterBetween: "Nằm giữa",
  filterBetweenInclusive: "Nằm giữa (Bao gồm cả hai)",
  filterByColumn: "Lọc theo {column}",
  filterContains: "Chứa",
  filterEmpty: "Trống",
  filterEndsWith: "Kết thúc bằng",
  filterEquals: "Bằng",
  filterEqualsString: "Bằng",
  filterFuzzy: "Tìm kiếm tương đối",
  filterGreaterThan: "Lớn hơn",
  filterGreaterThanOrEqualTo: "Lớn hơn hoặc bằng",
  filterIncludesString: "Chứa",
  filterIncludesStringSensitive: "Chứa (Phân biệt hoa thường)",
  filteringByColumn: "Đang lọc theo {column} - {filterType} {filterValue}",
  filterInNumberRange: "Trong khoảng",
  filterLessThan: "Nhỏ hơn",
  filterLessThanOrEqualTo: "Nhỏ hơn hoặc bằng",
  filterMode: "Chế độ lọc: {filterType}",
  filterNotEmpty: "Không trống",
  filterNotEquals: "Không bằng",
  filterStartsWith: "Bắt đầu bằng",
  filterWeakEquals: "Bằng",
  goToFirstPage: "Trang đầu",
  goToLastPage: "Trang cuối",
  goToNextPage: "Trang sau",
  goToPreviousPage: "Trang trước",
  grab: "Kéo",
  groupByColumn: "Nhóm theo {column}",
  groupedBy: "Đã nhóm theo",
  hideAll: "Ẩn tất cả",
  hideColumn: "Ẩn cột {column}",
  max: "Tối đa",
  min: "Tối thiểu",
  move: "Di chuyển",
  noRecordsToDisplay: "Không có dữ liệu để hiển thị",
  noResultsFound: "Không tìm thấy kết quả nào",
  of: "trên",
  or: "hoặc",
  pin: "Ghim",
  pinToLeft: "Ghim sang trái",
  pinToRight: "Ghim sang phải",
  resetColumnSize: "Khôi phục kích thước cột",
  resetOrder: "Khôi phục thứ tự",
  rowActions: "Thao tác hàng",
  rowNumber: "STT",
  rowNumbers: "Số thứ tự",
  rowsPerPage: "Hiển thị",
  save: "Lưu",
  search: "Tìm kiếm",
  select: "Chọn",
  selectedCountOfRowCountRowsSelected:
    "{selectedCount} trên {rowCount} hàng được chọn",
  showAll: "Hiển thị tất cả",
  showAllColumns: "Hiển thị tất cả các cột",
  showHideColumns: "Ẩn/Hiện cột",
  showHideFilters: "Ẩn/Hiện bộ lọc",
  showHideSearch: "Ẩn/Hiện tìm kiếm",
  sortByColumnAsc: "Sắp xếp tăng dần",
  sortByColumnDesc: "Sắp xếp giảm dần",
  sortedByColumnAsc: "Đã sắp xếp tăng dần",
  sortedByColumnDesc: "Đã sắp xếp giảm dần",
  thenBy: ", sau đó theo ",
  toggleDensity: "Thay đổi độ giãn dòng",
  toggleFullScreen: "Bật/Tắt toàn màn hình",
  toggleSelectAll: "Bật/Tắt chọn tất cả",
  toggleSelectRow: "Bật/Tắt chọn hàng",
  toggleVisibility: "Bật/Tắt hiển thị",
  ungroupByColumn: "Bỏ nhóm theo {column}",
  unpin: "Bỏ ghim",
  unpinAll: "Bỏ ghim tất cả",
};
